import { createAppAsyncThunk } from 'src/store/utils/thunks';

import type { AddApiKeyPayload, UpdateApiKeyPayload } from './types';
import { TradingApiCommands } from './types';
import { wsEsSend, createEsWsAction } from '@skynet/data-ws-es';

export interface ListenPayload {
  section?: string | null;
  token?: string;
  requestId?: string;
  accountID?: number;
  ticker?: string;
  timeframe?: string;
}

export const listen = createEsWsAction<ListenPayload, ListenPayload>(
  'tradingApiKeys/listen',
  (data) => ({
    command: 'Listen',
    ...data,
  }),
);

export const createApiKey = createAppAsyncThunk(
  'tradingApiKeys/createApiKey',
  (data: AddApiKeyPayload, thunkApi) =>
    thunkApi.dispatch(
      wsEsSend({
        command: TradingApiCommands.CreateESAPIKey,
        ...data,
      }),
    ),
);

export const updateApiKey = createAppAsyncThunk(
  'tradingApiKeys/updateApiKey',
  (data: UpdateApiKeyPayload, thunkApi) =>
    thunkApi.dispatch(
      wsEsSend({
        command: TradingApiCommands.UpdateESAPIKey,
        ...data,
      }),
    ),
);

export const deleteApiKey = createAppAsyncThunk(
  'tradingApiKeys/deleteApiKey',
  (accountID: number, thunkApi) =>
    thunkApi.dispatch(
      wsEsSend({
        command: TradingApiCommands.DeleteESAPIKey,
        accountID,
      }),
    ),
);
